import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReturnDetailScreen } from '@/features/purchasing-returns/return-detail-screen'
import { hasGrant } from '@/lib/me'

/** `.index` keeps this a sibling under `returns.tsx`'s own Outlet. */
export const Route = createFileRoute('/_authenticated/purchasing/returns/$returnId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'supplier_return.view')) {
      throw redirect({ to: '/purchasing/returns' })
    }
  },
  component: SupplierReturnDetailRoute,
})

function SupplierReturnDetailRoute() {
  const { returnId } = Route.useParams()

  return <ReturnDetailScreen returnId={returnId} />
}
